import $ from 'jquery'
import axios from 'axios'
import lottie from 'lottie-web'

$('.animation-shortcode').each(async (_index, element) => {
  const url = element.dataset.src
  const animationData = await axios.get(url).then(response => response.data)
  lottie.loadAnimation({
    animationData,
    container: element,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    rendererSettings: {
      className: 'svg-homepage-wrapper'
    }
  })
})
